<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="register">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            挂号列表
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledDel" @click.native="handleDel">作废</el-button>
                    <div style="float:right">
                        <el-select v-model="departmentDrugCode" placeholder="请选择科室" clearable style="margin:0 5px;float:left">
                            <el-option
                                    v-for="item in departmentDrugList"
                                    :key="item.departmentDrugCode"
                                    :label="item.name"
                                    :value="item.departmentDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="medicinerCode" placeholder="请选择医生" clearable style="margin:0 5px;float:left">
                            <el-option
                                    v-for="item in medicinerList"
                                    :key="item.medicinerCode"
                                    :label="item.name"
                                    :value="item.medicinerCode">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="status"
                            style="margin:0 5px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="visitType"
                            style="margin:0 5px;width:200px"
                            placeholder="请选择就诊状态">
                            <el-option
                                v-for="item in visitTypeValue"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                            </el-option>
                        </el-select>
                        <!-- <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin:0 5px;">
                        </el-date-picker> -->
                        <el-button style="margin-left:5px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;"  highlight-current-row @row-click='rowClick'>
                        <el-table-column prop="serialNumber" width="310" label="编号"></el-table-column>
                        <el-table-column prop="patientName" label="患者姓名"></el-table-column>
                        <el-table-column prop="departmentDrugName" label="就诊部门"></el-table-column>
                        <el-table-column prop="medicinerName" label="医生"></el-table-column>
                        <el-table-column prop="price" label="挂号费"></el-table-column>

                        <el-table-column
                                prop="status"
                                label="状态">
                                <template slot-scope="scope">
                                    <el-tag >{{statusTitle(scope.row.status)}}</el-tag>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="visitType"
                                label="就诊类型">
                                <template slot-scope="scope">
                                    <el-tag type="success">{{visitTypeTitle(scope.row.visitType)}}</el-tag>
                                </template>
                        </el-table-column>
                        <!-- <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status!=11" type="primary" size="small" @click="handleDel(scope.$index, scope.row)">作废</el-button>
                                <el-button v-else type="info" size="small">已作废</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:departmentDrugList="departmentDrugList"  v-bind:medicinerList="medicinerList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <GetPatient ref="myGetPatient" v-show="showModalGetPatient" v-on:closeGetPatient="closeGetPatient" v-on:openAdd="openAdd"></GetPatient>

    </div>
</template>

<script>
    import Add from "./Add";
    import GetPatient from "./GetPatient";
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                menuButtonList:null,
                row:null,
                showModalAdd:false,
                showModalEdit:false,
                disabledDel:true,
                showModalGetPatient:false,
                medicinerCode:"",
                departmentDrugCode:"",
                tableData:[],
                departmentDrugList:[],
                medicinerList:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                status:-1,
                visitType:-1,
                selectInfo:[],
                datetimerangeValue:'',
                visitTypeValue:[
                    {
                        val:-1,
                        name:'就诊类型'
                    },
                    {
                        val:1,
                        name:'初诊'
                    },
                    {
                        val:2,
                        name:'复诊'
                    },
                ],
                statusValue:[
                    {
                        val:-1,
                        name:'全部状态'
                    },{
                        val:1,
                        name:'已挂号'
                    },{
                        val:2,
                        name:'待诊中'
                    },{
                        val:3,
                        name:'诊疗中'
                    },{
                        val:4,
                        name:'已诊疗'
                    },{
                        val:11,
                        name:'作废'
                    }
                ],
                th:0,
                options:[]
            }
        },
        components:{
            Add,GetPatient
        },
        created(){
            this.init();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                const end= new Date();
                const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
                this.getDepartmentDrugList()
                this.getMedicinerList()
                this.getList();
            },
            getDepartmentDrugList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DepartmentDrug/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.departmentDrugList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getMedicinerList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Mediciner/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.medicinerList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            openAdd(data){
                this.closeAdd()
                this.$refs.myAdd.init(data);
            },
            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Register/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        medicinerCode:this.getCode(this.medicinerCode),
                        departmentDrugCode:this.getCode(this.departmentDrugCode),
                        visitType:this.visitType,
                        // startTime:timefilters(this.datetimerangeValue[0]).slice(0,10), 
                        // endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    this.disabledDel=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getCode(code){
                if(code){
                    return code;
                }else{
                    return '00000000-0000-0000-0000-000000000000'
                }
            },
            handleGetPatient(index, row) {
                this.$refs.myGetPatient.init(row);
                this.showModalGetPatient = !this.showModalGetPatient;
            },
            handleDel() {
                this.$confirm('此操作将作废此挂号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios({
                        method: 'post',
                        url: this.$institutionUrl+'Register/Abolish',
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            registerCode:this.selectInfo.registerCode,
                        }
                    }).then((response)=> {
                        if(response.data.error == 0){
                            this.$message({
                                type: 'success',
                                message: '作废成功!'
                            });
                            this.getList()
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消作废'
                    });          
                });
            },
            
            toggleModalAdd:function(){
                this.showModalGetPatient = !this.showModalGetPatient;
                this.$refs.myGetPatient.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalGetPatient:function(){
                this.showModalGetPatient = !this.showModalGetPatient;
            },
            closeGetPatient:function(){
                this.showModalGetPatient = !this.showModalGetPatient;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.init();
            },
            formatTime:function (row, column, cellValue) {
                return timefilters(cellValue);
            },
            statusTitle(status){
                for(var i in this.statusValue){
                    if(this.statusValue[i].val==status){
                        return this.statusValue[i].name
                    }
                }
                return "其它";
            },
            visitTypeTitle(visitType){
                for(var i in this.visitTypeValue){
                    if(this.visitTypeValue[i].val==visitType){
                        return this.visitTypeValue[i].name
                    }
                }
                return "其它";
            },
            rowClick(row){
                this.disabledDel=true
                this.selectInfo=row
                if(row.status==1){
                    if(this.menuButtonList.indexOf("作废")!=-1){
                    this.disabledDel =false;
                    }
                }   
            }

        }
    }
</script>

<style lang="scss" scoped>
    .register /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>